import { useEffect, useState } from 'react';
import logo from '../app-assets/images/logo/stack-logo.png';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function Header({ sidebarOpen, setSidebarOpen }) {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        // Load initial user data
        const user = localStorage.getItem('user');
        if (user) {
            setUserData(JSON.parse(user));
        }

        const handleStorageChange = () => {
            const user = localStorage.getItem('user');
            if (user) {
                setUserData(JSON.parse(user));
            }
        };

        // Listen for custom event when profile updates
        window.addEventListener('userProfileUpdated', handleStorageChange);
        // Also listen for storage changes from other tabs
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('userProfileUpdated', handleStorageChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        if (window.feather) {
            window.feather.replace();
        }

        if (window.$ && window.$.fn) {
            window.$('.dropdown-toggle').dropdown();

            window.$('[data-toggle="collapse"]').each(function () {
                const target = window.$(this).data('target');
                window.$(target).collapse();
            });

            if (window.initMenu) {
                window.initMenu();
            }
        }
    }, [userData]);

    const username = userData?.username || 'Guest';
    const userStatus = userData?.status || 'Active';
    const defaultAvatarFallback = '/app-assets/images/portrait/small/avatar-s-1.png';
    const avatarUrl = userData?.avatar
        ? `${API_BASE.replace('/api', '')}/uploads/avatars/${userData.avatar}`
        : defaultAvatarFallback;

    return (
        <>
            <style>{`
                /* Header responsive styles */
                .header-navbar {
                    padding: 0.5rem 1rem;
                    min-height: 60px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                
                @media (max-width: 575px) {
                    .header-navbar {
                        padding: 0.25rem 0.5rem;
                        min-height: 50px;
                    }
                    
                    .navbar-brand img {
                        height: 24px !important;
                        max-height: 24px !important;
                    }
                    
                    .navbar-brand h2 {
                        font-size: 1.1rem !important;
                        margin: 0;
                    }
                    
                    .nav-link {
                        padding: 0.5rem !important;
                    }
                    
                    .feather.icon-menu {
                        font-size: 1.2rem;
                    }
                    
                    .avatar {
                        width: 28px !important;
                        height: 28px !important;
                    }
                    
                    .avatar img {
                        width: 28px !important;
                        height: 28px !important;
                    }
                    
                    .user-name {
                        font-size: 0.9rem;
                        max-width: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    
                    .dropdown-menu {
                        min-width: 150px;
                        font-size: 0.9rem;
                    }
                }
                
                @media (min-width: 576px) and (max-width: 767px) {
                    .header-navbar {
                        padding: 0.5rem 0.75rem;
                    }
                    
                    .navbar-brand h2 {
                        font-size: 1.2rem;
                    }
                    
                    .user-name {
                        font-size: 0.95rem;
                    }
                }
                
                @media (min-width: 768px) {
                    .header-navbar {
                        padding: 0.75rem 1rem;
                    }
                }
                
                /* Touch-friendly improvements */
                @media (max-width: 767px) {
                    .nav-link {
                        min-height: 44px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle::after {
                        margin-left: 0.5em;
                    }
                    
                    .dropdown-item {
                        padding: 0.75rem 1rem;
                        font-size: 0.9rem;
                    }
                    
                    .feather {
                        width: 18px;
                        height: 18px;
                    }
                }
            `}</style>
            
            <nav className="header-navbar navbar-expand-md navbar navbar-with-menu fixed-top navbar-light navbar-border">
                <div className="navbar-wrapper">
                    <div className="navbar-header">
                        <ul className="nav navbar-nav flex-row align-items-center">
                            <li className="nav-item mobile-menu d-lg-none mr-auto">
                                <button 
                                    type="button"
                                    className="nav-link nav-menu-main menu-toggle btn border-0 bg-transparent p-2"
                                    onClick={() => setSidebarOpen && setSidebarOpen(!sidebarOpen)}
                                    style={{ minHeight: '44px', minWidth: '44px' }}
                                    aria-label="Toggle menu"
                                >
                                    <i className="feather icon-menu font-large-1" />
                                </button>
                            </li>
                            <li className="nav-item">
                                <a className="navbar-brand d-flex align-items-center" href="/">
                                    <img className="brand-logo" alt="stack admin logo" src={logo} style={{ height: '32px', maxHeight: '32px' }} />
                                    <h2 className="brand-text mb-0 ml-2">MPA</h2>
                                </a>
                            </li>
                            <li className="nav-item d-md-none">
                                <a className="nav-link open-navbar-container p-2" data-toggle="collapse" data-target="#navbar-mobile" href="/">
                                    <i className="fa fa-ellipsis-v" />
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="navbar-container content">
                        <div className="collapse navbar-collapse" id="navbar-mobile">
                            <ul className="nav navbar-nav mr-auto float-left">
                                <li className="nav-item d-none d-lg-block">
                                    <button 
                                        type="button"
                                        className="nav-link nav-menu-main menu-toggle btn border-0 bg-transparent p-2"
                                        onClick={() => setSidebarOpen && setSidebarOpen(!sidebarOpen)}
                                        aria-label="Toggle menu"
                                    >
                                        <i className="feather icon-menu" />
                                    </button>
                                </li>
                            </ul>
                            <ul className="nav navbar-nav float-right">
                                <li className="dropdown dropdown-user nav-item">
                                    <a className="dropdown-toggle nav-link dropdown-user-link d-flex align-items-center" href="/" data-toggle="dropdown">
                                        <div className={`avatar mr-2 ${userStatus === 'Active' ? 'avatar-online' : 'avatar-offline'}`}>
                                            <img src={avatarUrl} alt="avatar" className="rounded-circle" style={{ width: '32px', height: '32px', objectFit: 'cover' }} />
                                            <i />
                                        </div>
                                        <span className="user-name d-none d-sm-inline-block">{username}</span>
                                        {userStatus !== 'Active' && <span className="badge badge-sm badge-danger ml-1">{userStatus}</span>}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a className="dropdown-item" href="/profile"><i className="feather icon-user mr-2" /> Edit Profile</a>
                                        <div className="dropdown-divider" />
                                        <a className="dropdown-item" href="/logout" onClick={(e) => { e.preventDefault(); localStorage.removeItem('token'); localStorage.removeItem('user'); try { sessionStorage.removeItem('reminder_alert_session_start'); } catch {} window.location.replace('/login'); }}>
                                            <i className="feather icon-power mr-2" /> Logout
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}

